import { FC, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Layout, IButton, ICheckbox } from "../../../../ui-kit";
import { systemSettingsStore } from "../../../../store/systemSettingsStore";
import Paths from "../../../../constants/PathsBreadcrumbs";
import { useBreadcrumbs } from "../../../../hooks/useBreadcrumbs";
import { useStatusMessage } from "../../../../hooks/useStatusMessage";
import { observer } from "mobx-react-lite";
import styles from "./SitpanelSetting.module.scss";

const SitpanelSetting: FC = observer(() => {
  useBreadcrumbs(Paths.adminSitpanelSetting);

  const {
    getSitPanelConfig,
    isLoading,
    sitPanelConfig,
    updateSitPanelConfig,
    messageStatus,
  } = systemSettingsStore;

  const defaultValues = {
    showAllDefects: false,
  };

  const { handleSubmit, reset, control } = useForm({
    defaultValues,
  });

  const onSubmit = (data) => {
    updateSitPanelConfig(data);
  };

  useEffect(() => {
    getSitPanelConfig();
  }, []);

  useEffect(() => {
    if (sitPanelConfig) {
      reset(sitPanelConfig);
    }
  }, [sitPanelConfig]);

  useStatusMessage(messageStatus);

  return (
    <Layout type="white">
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          name="showAllDefects"
          render={({ field: { value, onChange } }) => (
            <ICheckbox
              checked={value}
              onChange={onChange}
              label="Отображать все дефекты для РСО"
            />
          )}
        />
        <IButton loading={isLoading.value}>Сохранить</IButton>
      </form>
    </Layout>
  );
});

export default SitpanelSetting;
